import Vue from 'vue'
import mutations from './mutations'
import orderApi from '../../api/orders'
import { loadItemsBuilder } from '../crudFactory'
const apiEndpoint = 'orders'

export default {
  namespaced: true,

  state: {
    items: [],
    openedOrders: []
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    async loadOrdersByDate ({ state, rootState, commit }, { dateFrom, dateTo, dateEndFrom, dateEndTo, type = 0 }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      var orders = await orderApi.getAllBetweenDates({ businessUnitId, dateFrom, dateTo, dateEndFrom, dateEndTo, type })
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let filteredOrders = orders.data.items.filter(x => !type1Tables.includes(x.table))
      commit('setOrders', filteredOrders)
      return filteredOrders
    },
    async loadType1OrdersByDate ({ state, rootState, commit }, { dateFrom, dateTo, dateEndFrom, dateEndTo, type = 0 }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let requests = type1Tables.map(x =>
        orderApi.getAllBetweenDates({
          businessUnitId,
          table: x,
          dateFrom,
          dateTo,
          dateEndFrom,
          dateEndTo,
          type
        })
      )
      const responses = await Promise.all(requests)
      const orders = responses.flatMap(response => response.data.items)
      let filteredOrders = orders.filter(x => type1Tables.includes(x.table))
      commit('setOrders', filteredOrders)
      return filteredOrders
    },
    async loadOpenedOrders ({ state, rootState, commit }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      var orders = await orderApi.getOpenedOrders({ businessUnitId })
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let filteredOrders = orders.data.items.filter(x => !type1Tables.includes(x.table))
      commit('setOpenedOrders', filteredOrders)
      return filteredOrders
    },
    async loadOpenedType1Orders ({ state, rootState, commit }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      let type1Tables = Object.values(rootState.tables.items).filter(x => x.type === 1).map(x => x.id)
      let requests = type1Tables.map(x =>
        orderApi.getOpenedOrders({
          businessUnitId,
          table: x
        })
      )
      const responses = await Promise.all(requests)
      const orders = responses.flatMap(response => response.data.items)
      let filteredOrders = orders.filter(x => type1Tables.includes(x.table))
      commit('setOpenedOrders', filteredOrders)
      return filteredOrders
    },
    async createOrder ({ state, rootState, dispatch }, data) {
      const deviceCms = await dispatch('devices/loadCentralDevice', {}, { root: true })
      const electronicDeviceId = deviceCms.id
      var order = await orderApi.createOrder({ electronicDeviceId, data })
      return order
    }
  },

  mutations: {
    ...mutations,
    setOrders (state, orders) {
      Vue.set(state, 'items', orders)
    },
    setOpenedOrders (state, orders) {
      Vue.set(state, 'openedOrders', orders)
    }
  }
}
